import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {concatMap, map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';

import {endpoints} from '../../endpoints';
import { CatalogosService } from '../../catalogos.service';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesService {

  constructor(private http: HttpClient, private catalogoService: CatalogosService) {
  }

  getSolicitudes(filters): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

      const params = Object.keys(filters)
      .map((key) => key + '=' + filters[key])
      .join('&');

    return this.http.post(endpoints.core.obtenerSolicitudes  + '?' + params, { filters: JSON.stringify(filters) }, {headers}).pipe(
      map((results: any) => {
        if (results.success) {
          let total = results.data.instancias.total;
          let data = results.data.instancias.data.map((instancia) => {
            instancia.editable = ['NUEVA.SOLICITUD', 'OBSERVACION.FORMA', 'OBSERVACION.FONDO'].includes(
              instancia.estado.codigo_estado_proceso
            );
            return instancia;
          });
          return { data, total };
        }

        //return results;
        return [];
      }),
      catchError(error => {
        throw new Error(error.error.message);
      })
    );
  }

  /**
   * Las columnas se obtienen de version_procesos.detalles y contiene un arreglo de
   * campos de datos_solicitud a incluir en la tabla. Esos campos se buscan en la estructura
   * de datos y se mandan como lista a la tabla. "res" es el resultSet que se obtiene del API
   * y arreglo es la parte del objeto donde se encuentran los datos a buscar.
   */
  getDetalles(res, arreglo, subarray = null) {
    let datos = arreglo === null ? res : res.data[arreglo];
    datos.forEach((element, index) => {
      if (subarray) {
        (element.contiene = element.contiene ?? element[subarray].contiene)
        (element.detalles = element.version_proceso !== undefined ? element.version_proceso.detalle : element.detalles ?? element[subarray].detalles); }
      else {
        element.detalles = element.version_proceso !== undefined ? element.version_proceso.detalles : element.detalles;
      }
      element.detalles = this.forDetalle(element, index, element.detalles);
    }, datos);
    return res;
  }

  forDetalle(data, index, detalle): any {
    let detArray = [];
    if (detalle !== undefined && detalle !== null) {
      let det = JSON.parse(detalle);
      let value;
      let label;
      if (data.contiene) {
        data.contiene = data.contiene
          .replace('[', '.')
          .replace(']', '')
          .replace('$.', '');
        label = data.contiene.slice(
          data.contiene.lastIndexOf('.') + 1 != 0
            ? data.contiene.lastIndexOf('___') != -1 &&
            data.contiene.lastIndexOf('___') >
            data.contiene.lastIndexOf('.')
              ? data.contiene.lastIndexOf('___')
              : data.contiene.lastIndexOf('.') + 1
            : data.contiene.lastIndexOf('___'),
          -1
        );
        label = label.replaceAll('_', ' ').replaceAll('"', '').trim();
        label = label.charAt(0).toUpperCase() + label.toLowerCase().slice(1);
        value = data.contiene.replaceAll('"', '').trim();
        det = [{ label, value }];
      }
      det.forEach((d) => {
        if (detArray.length < 6) {
          let sub: boolean;

          if (d) {
            let datos_solicitud = {};
            let process_name = '';
            if (data.datos_solicitud && data.datos_solicitud !== '{}') {
              datos_solicitud = JSON.parse(data.datos_solicitud);
              var test_name = Object.keys(datos_solicitud)[0];
              process_name = test_name?.substr(0, test_name.indexOf('___')) + '___';
            } else {
              detArray.push(d);
            }
            if (process_name == 'undefined___') detArray.push(d);
            // let detallesJson = JSON.parse(d);
            let inDet;
            if (d.defaultValue){
              var val = d.value;
            } else if (typeof(d.value) === 'string') {
              var val = d.value.split('.').reduce((o, i) => {
                var keyCaseInsensitive =
                  o !== undefined && o!==null
                    ? Object.keys(o).find(
                      (key) =>
                        key.toLowerCase() === i.toLowerCase() ||
                        key.toLowerCase() === (process_name + i).toLowerCase()
                    )
                    : '';
                return o !== undefined  && o!==null
                  ? Number.isInteger(parseFloat(i))
                    ? o[parseInt(i)]
                    : o[keyCaseInsensitive]
                  : null;
              }, datos_solicitud);
            } else if (typeof(d.value) === 'object') {
              var val = null;
              d.value.forEach(element => {
                let wval = element.split('.').reduce((o, i) => {
                  var keyCaseInsensitive =
                    o !== undefined && o!==null
                      ? Object.keys(o).find(
                        (key) =>
                          key.toLowerCase() === i.toLowerCase() ||
                          key.toLowerCase() === (process_name + i).toLowerCase()
                      )
                      : '';
                  return o !== undefined && o!==null
                    ? Number.isInteger(parseFloat(i))
                      ? o[parseInt(i)]
                      : o[keyCaseInsensitive]
                    : null;
                }, datos_solicitud);
                if (wval !== undefined && wval !== null) val = val ? val + ' ' + wval : wval;
              });
              }

              let verified_value = val ?? '--No ingresado--';

              if (d.catalog) {
                if (verified_value !== '--No ingresado--') {
                  this.catalogoService.getDataFromCatalog(d.catalog, verified_value).subscribe((res) => {
                    verified_value = res.attributes[d.prop] ?? '--No ingresado--';
                    inDet = '<strong>' + d.label + ': </strong>' + verified_value;
                    detArray.push(inDet);
                  });
                } else {
                  inDet = '<strong>' + d.label + ': </strong>' + verified_value;
                  detArray.push(inDet);
                }
              } else {
                inDet = '<strong>' + d.label + ': </strong>' + verified_value;
                detArray.push(inDet);
              }
            }
          } else {
            detArray.push(d);
          }
        }
      );
    }
    return detArray;
  }

  guardarEstadoInstancia(idInstancia, idEstado) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      id_instancia: idInstancia,
      id_estado: idEstado
    };

    return this.http.post(endpoints.core.guardarEstadoInstancia, parametros, {headers})
      .pipe(map((results: any) => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  guardarDesistimientoInstancia(idInstancia, idEstado, nota) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      id_instancia: idInstancia,
      id_estado: idEstado,
      nota: nota
    };

    return this.http.post(endpoints.core.guardarDesistimientoInstancia, parametros, {headers})
      .pipe(map((results: any) => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  EliminarSolicitud(idInstancia) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      id_solicitud: idInstancia
    };

    return this.http.post(endpoints.core.eliminarInstancia, parametros, {headers})
      .pipe(map((results: any) => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  guardarProrrogaInstancia(idInstancia,iddoc,tipodoc): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      id: idInstancia,
      iddoc:iddoc,
      tipodoc:tipodoc
    };

    return this.http.post(endpoints.core.prorrogaInstancia, parametros, {headers})
      .pipe(map((results: any) => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  crearSubirDocumento(tipoDocumento: string, file: File) {
        return this.crearDocumento(tipoDocumento).pipe(
          concatMap((response) => {
            return this.subirDocumento(response.url, response.uuid, file);
          })
        );
  }
  private crearDocumento(tipoDocumento: string) {
    const body = {
        tipo_documento: tipoDocumento,
        meta_datos: {}
    };

    return this.http.post(endpoints.gestordocumental.subirArchivo, body).pipe(
        map((response: any) => {
            return {
                uuid: response.data.uuid,
                url: response.data.url,
                data: response.data
            };
        })
    );
  }
  private subirDocumento(url: string, uuid: string, file: File){
    const formData = new FormData();
    formData.append('archivo', file, file.name);

    return this.http.post(url, formData).pipe(
        map((response: any) => {
            return uuid;
        })
    );
  }

   descargarDocumento(uuid: string) {
    return this.http.get(endpoints.gestordocumental.descargarArchivo + uuid, {
      responseType: 'blob',
    });
  }
}
